jQuery( document ).ready(function( $ ) {

    $(window).load(function() {
        $('.logoStrip').marquee({
            duration: 20000,
            duplicated: true,
            allowCss3Support: true
        });
    });

});